let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6vQht")).then(() => parcelRequire('5xGJU'));